import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// the translations
const resources = {}

process.env.GATSBY_LOCALES.split(',').forEach(
  (lang) =>
    (resources[lang] = {
      scout: require(`../../locales/scout/${lang}.json`),
      listings: require(`../../locales/listings/${lang}.json`),
      valuation: require(`../../locales/valuation/${lang}.json`),
      common: require(`../../locales/common/${lang}.json`),
    })
)

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: {
      // order and from where user language should be detected
      order: ['path'],
      // keys or params to lookup language from
      lookupFromPathIndex: 0,
    },
    initImmediate: false,
    preload: ['en', 'fi', 'sv', 'nb'],
    ns: ['scout', 'listings', 'valuation', 'common'],
    defaultNS: 'common',
    resources,
    supportedLngs: process.env.GATSBY_LOCALES.split(','),
    fallbackLng: process.env.GATSBY_DEFAULT_LOCALE,
    nsSeparator: ':',
    keySeparator: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false,
    },
  })

export default i18n
